const CHART_BASE = "/assets/images/onboarding/wizard/result-charts";

export const RESULT_CHART_ASSETS = {
  shared: {
    payoffSparkle: `${CHART_BASE}/shared/payoff-sparkle.svg`,
  },
  million: {
    targetDashed: `${CHART_BASE}/million/chart-1m-dashed.svg`,
  },
} as const;
